__webpack_require__.p = "https://storage.yandexcloud.net/personal-website-storage/static/";